import { render, staticRenderFns } from "./Packages.vue?vue&type=template&id=a82a9d56&scoped=true"
import script from "./Packages.vue?vue&type=script&lang=ts"
export * from "./Packages.vue?vue&type=script&lang=ts"
import style0 from "./Packages.vue?vue&type=style&index=0&id=a82a9d56&prod&scoped=true&lang=css"
import style1 from "./Packages.vue?vue&type=style&index=1&id=a82a9d56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82a9d56",
  null
  
)

export default component.exports